import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d95d036"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#fff"} }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { style: {"font-size":"15px","line-height":"50px","border-bottom":"1px solid #E1E3E5"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: _ctx.search_value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search_value) = $event)),
      shape: "round",
      placeholder: "请输入搜索关键词",
      onSearch: _ctx.onSearch
    }, null, 8, ["modelValue", "onSearch"]),
    _createVNode(_component_van_list, {
      loading: _ctx.state.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.loading) = $event)),
      finished: _ctx.state.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (user) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass({
            'uf-staff-selector__item--active': _ctx.state.checked?.id === user.id
          }),
              key: user.id,
              onClick: ($event: any) => (_ctx.onClick(user)),
              style: {"padding":"0 20px"}
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(user.name), 1)
            ], 10, _hoisted_2))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])
  ]))
}